import { suggestedFriendsQueryOptions } from '@/api/queries/friendship';
import { useQuery } from '@tanstack/react-query';

export function useSuggestedFriends(limit?: number) {
  return useQuery(suggestedFriendsQueryOptions({ limit }));
}
